<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <i *ngIf="currentStep === STEPS.ADD_DATA" class="icon-small-back" (click)="onGoBack(STEPS.SELECT_TYPE)"></i>
        <i *ngIf="currentStep === STEPS.RECAP" class="icon-small-back" (click)="onGoBack(STEPS.ADD_DATA)"></i>
        <h4 translate>company.dids.activate-testing-did.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <!-- START - STEP SELECT_TYPE -->
      <section *ngIf="currentStep === STEPS.SELECT_TYPE" class="select-type">
        <div class="main">
          <h5 class="vox-heading-5" translate>company.dids.activate-testing-did.select-type.how</h5>
          <div class="vox-input-group">
            <label class="vox-field-label">
              <input class="vox-radio" type="radio" value="vd" [(ngModel)]="selection"
                (click)="selection = 'vd'" />{{'company.dids.activate-testing-did.select-type.vd' | translate}}</label>
          </div>
          <div class="vox-input-group">
            <label class="vox-field-label">
              <input class="vox-radio" type="radio" value="portability" [(ngModel)]="selection"
                (click)="selection = 'portability'" />{{'company.dids.activate-testing-did.select-type.portability' |
              translate}}</label>
          </div>
          <div class="submit-container">
            <button class="vox-btn vox-btn-primary" type="button" (click)="onGoNext(STEPS.ADD_DATA)"
              translate>company.dids.activate-testing-did.buttons.next</button>
          </div>
        </div>
      </section>
      <!-- END - STEP SELECT_TYPE -->
      <!-- START - STEP ADD_DATA -->
      <section *ngIf="currentStep === STEPS.ADD_DATA" class="add-data">
        <div class="main">
          <!-- Portability activation -->
          <ng-container class="portability" *ngIf="selection === 'portability'">
            <div class="number-container">
              <div class="number-container__title">
                <h4 class="vox-heading-4" translate>company.dids.activate-testing-did.add-data.portability.number.title
                </h4>
              </div>
              <div class="number-container__main">
                <p class="vox-paragraph">
                  <span [title]="did.country"
                    class="flag-icon flag-icon-{{(did.country || 'unknown') | lowercase}}"></span>
                  {{did.number}}
                </p>
                <p class="vox-paragraph">{{did.did_class | didClass}}</p>
                <p class="vox-paragraph">{{did.did_type | didType}}</p>
              </div>
            </div>
            <div class="vox-inline-message vox-inline-message_light-grey">
              <div>
                <i class="icon-small-alert"></i>
                <span
                  [innerHTML]="'company.dids.activate-testing-did.add-data.portability.disclaimer' | translate"></span>
              </div>
            </div>
            <div class="upload-docs-contrainer" *ngIf="!loading.submit">
              <gdp-upload-portability-docs-form [country]="did.country" (onEmitDocs)="portabilityDocsForm = $event">
              </gdp-upload-portability-docs-form>
              <div class="submit-container">
                <button type="button" class="vox-btn vox-btn-primary" type="button" [disabled]="!canSubmit"
                  (click)="planAddonHandling === 'manual' ? onSubmit() : onGoNext(STEPS.RECAP)"
                  [ladda]="loading.submit" data-style="zoom-in" data-spinner-color="#fff">
                  <span *ngIf="planAddonHandling !== 'manual'" translate>company.dids.activate-testing-did.buttons.next</span>
                  <span *ngIf="planAddonHandling === 'manual'" translate>company.dids.activate-testing-did.buttons.activate</span>
                </button>
              </div>
            </div>
            <div class="upload-docs-contrainer" *ngIf="loading.submit">
              <ngx-skeleton-loader [theme]="{'height':'916px'}"></ngx-skeleton-loader>
            </div>
          </ng-container>
          <!-- Verification data activation -->
          <ng-container class="vd" *ngIf="selection === 'vd' && !loading.vd">
            <gdp-verification-data-selection-form *ngIf="isVDRequired" [language]="language" [country]="did.country"
              [dids]="didsWithVerificationData" [requirements]="requirements" [allowNoVD]="false"
              (onEmitVerificationData)="onFormChange($event)"></gdp-verification-data-selection-form>
            <div *ngIf="!isVDRequired" class="vox-inline-message vox-inline-message_light-grey">
              <div>
                <i class="icon-small-info"></i>
                <span translate>company.dids.activate-testing-did.add-data.vd.no-vd</span>
              </div>
            </div>
            <div class="submit-container mt-3">
              <button class="vox-btn vox-btn-primary" type="button" [disabled]="!canSubmit"
                (click)="planAddonHandling === 'manual' ? onSubmit() : onGoNext(STEPS.RECAP)"
                [ladda]="loading.submit" data-style="zoom-in" data-spinner-color="#fff">
                <span *ngIf="planAddonHandling !== 'manual'" translate>company.dids.activate-testing-did.buttons.next</span>
                <span *ngIf="planAddonHandling === 'manual'" translate>company.dids.activate-testing-did.buttons.activate</span>
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="selection === 'vd' && loading.vd">
            <div class="form-group">
              <ngx-skeleton-loader
                [theme]="{'height':'24px', 'width': '150px', 'margin-bottom':'6px', 'margin-top':'0px'}">
              </ngx-skeleton-loader>
              <ngx-skeleton-loader [theme]="{'height':'40px', 'margin-top':'-5px'}"></ngx-skeleton-loader>
            </div>
            <div>
              <ngx-skeleton-loader [theme]="{'height':'450px'}"></ngx-skeleton-loader>
            </div>
          </ng-container>
        </div>
      </section>
      <!-- END - STEP ADD_DATA -->
      <!-- START - STEP RECAP -->
      <section *ngIf="currentStep === STEPS.RECAP" class="recap">
        <ng-container>
          <gdp-payment-info [product]="product" [country]="did.country" [didId]="did.id"
            [chargebeeAccount]="subscription.chargebee_account" [companyId]="companyId" [canModifyCoupon]="true">
          </gdp-payment-info>
          <gdp-subscription-change-checkboxes (onEmitFormValue)="checkboxesData = $event">
          </gdp-subscription-change-checkboxes>
          <div class="submit-container">
            <button class="vox-btn vox-btn-primary" type="submit" [disabled]="!checkboxesData.isValid || !canSubmit"
              [ladda]="loading.submit" data-style="zoom-in" data-spinner-color="#fff" (click)="onSubmit()">
              <span translate>company.dids.activate-testing-did.buttons.activate</span>
            </button>
          </div>
        </ng-container>
      </section>
      <!-- END - STEP RECAP -->
    </div>
  </div>
</div>